export default __webpack_public_path__ + "static/media/logo_verde.59ae1965.png";